import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class EbEmployeeDashboardDetailsService {
  routePrefix = '/api/eb-dashboard/v2';
  requestTokenKey = 'requestToken';
  requestToken: string;
  private isVireMoreSelectedSource = new BehaviorSubject<boolean>(null);
  isViewMoreSelectedChanges$ = this.isVireMoreSelectedSource.asObservable();
  constructor(private http: HttpClient) { }

  getRequestTokenHeader(): HttpHeaders {
    this.requestToken = sessionStorage.getItem(this.requestTokenKey);
    return new HttpHeaders().set(this.requestTokenKey, this.requestToken);
  }

  hasClaimUsageAndLifeCard(policyNumber: string): Observable<any>{
    return this.http.get(this.routePrefix + '/has-claim-usage-and-life-card/' + policyNumber, { headers: this.getRequestTokenHeader() });
  }

  getByEnrolId(enrolId: number): Observable<any>{
    return this.http.get(this.routePrefix + '/landing-page-details/' + enrolId, { headers: this.getRequestTokenHeader() });
  }

  getClaimHistoriesByEnrolId(enrolId: number): Observable<any>{
    return this.http.get<any>(this.routePrefix + '/claim-history-details/' + enrolId, { headers: this.getRequestTokenHeader() });
  }

  changeSelectedViewMore(isSelected: boolean){
    this.isVireMoreSelectedSource.next(isSelected);
  }

  getClaimStatusDetails(claimEntryId:number): Observable<any>{
    return this.http.get<any>(this.routePrefix + '/' + claimEntryId + '/claim-status-details', { headers: this.getRequestTokenHeader() });
  }

  getAllActiveMembersByEnrolId(enrolId:number): Observable<any> {
    return this.http.get(this.routePrefix + '/all-active-members/' + enrolId, { headers: this.getRequestTokenHeader() })
  }
}
